import React from 'react';
import { ArrowPathIcon, ArrowRightStartOnRectangleIcon, CloudIcon } from '@heroicons/react/24/outline';

// Shown to an AUTHENTICATED user when /api/me could not be reached (network
// failure, 5xx, or an FC1 host stall after a deploy) — i.e. we could not ask
// whether they are entitled, so we must NOT tell them they are denied.
//
// Deliberately says nothing about security groups or administrators: the old
// "Access Denied" copy did, which sent entitled users hunting for a
// non-existent permission problem and invited a privilege-escalating "fix".
// See Issues/2026-08-19_Api-Outage-Renders-As-Access-Denied.
export default function ServiceUnavailable({ onRetry, onLogout }) {
  const retry = onRetry || (() => window.location.reload());
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <div className="text-center max-w-md">
        <CloudIcon className="h-16 w-16 text-amber-400 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-100 mb-2">
          Can’t reach the service
        </h1>
        <p className="text-gray-400 mb-4">
          You’re signed in, but the Blue365Signal Portal service isn’t responding
          right now. This is usually temporary — please wait a moment and try again.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          If it persists for more than a few minutes, let your Blue Alliance contact
          know that the portal service is unavailable.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={retry}
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white font-medium rounded-lg transition-colors"
          >
            <ArrowPathIcon className="h-5 w-5" />
            Retry
          </button>
          <button
            onClick={onLogout}
            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-gray-200 font-medium rounded-lg transition-colors"
          >
            <ArrowRightStartOnRectangleIcon className="h-5 w-5" />
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
